import React from "react"
import DatesHelper from "../datesHelper";
import Period from "../period";
import { DatePicker } from "./datepicker"
import { InputError } from "./inputError"
interface PeriodInputProps {
    period: Period | null;
    allowedRange?: Period;
    error?: string;
    labelFrom?: string;
    labelTo?: string;
    onChange: (period: Period) => void;
    format?: string;
    editFormat?: string;
    timeFormat?: string;
    disabled?: boolean;
    maxSelectableDays?: number;
}

export class PeriodInput extends React.PureComponent<PeriodInputProps>
{
    onChangeStart = (from: Date | null) => {
        if (from == null) return;
        var to = this.props.period?.to ?? DatesHelper.MaxDate;
        if (to < from || to == null)
            to = new Date(from.valueOf());
        if (this.props.maxSelectableDays) {
            if (Math.abs(DatesHelper.differenceInDays(to, from).days) > this.props.maxSelectableDays) {
                var daysToAdd = this.props.maxSelectableDays >= 1 ? this.props.maxSelectableDays - 1 : this.props.maxSelectableDays;
                to = DatesHelper.AddDays(from, daysToAdd);
            }
        }
        this.props.onChange(Period.Create(from, DatesHelper.EndOfDay(to)));
    }

    onChangeEnd = (to: Date | null) => {
        if (to == null) return;
        var from = this.props.period?.from ?? DatesHelper.MinDate;
        if (to < from || from == null)
            from = new Date(to.valueOf());
        if (this.props.maxSelectableDays) {
            if (Math.abs(DatesHelper.differenceInDays(to, from).days) > this.props.maxSelectableDays) {
                var daysToAdd = this.props.maxSelectableDays >= 1 ? this.props.maxSelectableDays - 1 : this.props.maxSelectableDays;
                from = DatesHelper.AddDays(to, -daysToAdd);
            }
        }
        this.props.onChange(Period.Create(from, DatesHelper.EndOfDay(to)));
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    <DatePicker
                        readOnly={this.props.disabled}
                        label={this.props.labelFrom}
                        value={this.props.period?.from}
                        onSelectDate={this.onChangeStart}
                        dateRange={this.props.allowedRange}
                    />
                </div>
                <div className="col-12 col-md-6">
                    <DatePicker
                        readOnly={this.props.disabled}
                        label={this.props.labelTo}
                        value={this.props.period?.to}
                        onSelectDate={this.onChangeEnd}
                        dateRange={this.props.allowedRange}
                    />
                </div>
                <InputError error={this.props.error} />
            </div>
        );
    }
}


export interface DateTimePeriodInputProps {
    period: Period;
    maxHours?: number;
    disabled?: boolean;
    error?: string;
    labelFrom?: string;
    labelTo?: string;
    noForm?: boolean;
    onChange: (period: Period) => void;
}

export class DateTimePeriodInput extends React.PureComponent<DateTimePeriodInputProps>
{
    private onChangeStart = (from: Date) => {
        var to = this.props.period.to;
        if (to.valueOf() < from.valueOf()) {
            to = new Date(from.valueOf());
        }
        if (this.props.maxHours != null) {
            var twoDaysLater = DatesHelper.AddHours(from, this.props.maxHours);
            if (to.valueOf() > twoDaysLater.valueOf()) {
                to = twoDaysLater;
            }
        }
        this.props.onChange(Period.Create(from, to));
    }

    private onChangeEnd = (to: Date) => {
        var from = this.props.period.from;
        if (from.valueOf() > to.valueOf()) {
            from = new Date(to.valueOf());
        }
        if (this.props.maxHours != null) {
            var twoDaysBefore = DatesHelper.AddHours(to, -this.props.maxHours);
            if (from.valueOf() < twoDaysBefore.valueOf()) {
                from = twoDaysBefore;
            }
        }

        this.props.onChange(Period.Create(from, to));
    }

    render() {
        return (
            <div>
                <DatePicker
                    readOnly={this.props.disabled}
                    label={this.props.labelFrom}
                    value={this.props.period.from}
                    onSelectDate={this.onChangeStart}
                />
                <DatePicker
                    readOnly={this.props.disabled}
                    label={this.props.labelTo}
                    value={this.props.period.to}
                    onSelectDate={this.onChangeEnd} />
                <InputError error={this.props.error}
                />
            </div>
        );
    }
}

export default PeriodInput;